import React from 'react';

import { Typography } from '@mui/material';

import createBlockInputSection from './helpers/createBlockInputSection';
import { LiquidHelperText } from './helpers/templatableHelperText';
import HideSectionInput from './special-inputs/HideSectionInput';

const HtmlSidebarForm = createBlockInputSection({
  title: 'HTML block',
  inputs: [
    {
      type: 'code',
      props: {
        label: '',
        resizeVertical: true,
        name: 'text',
        helperText: (
          <Typography variant="body2" color="text.secondary" sx={{ mt: (theme) => `${theme.spacing(1)} !important` }}>
            <LiquidHelperText />
          </Typography>
        ),
      },
    },
    'color',
    'backgroundColor',
    'fontFamily',
    'fontSize',
    'textAlign',
    'padding',
    HideSectionInput,
  ],
});

export default HtmlSidebarForm;
